<template>
  <div class="textTransformUI">
    <div class="textTransform" v-show="isModeTextTrans">
      <div class="textTransform__header">
        <div class="buttonMini bold" @click="cancelEdit">キャンセル</div>
        <div class="buttonMini button--primaryColor" @click="completeEdit">
          OK
        </div>
      </div>
      <div class="textTransform__footer ">
        <div class="transUIButtons">
          <div
            class="transUIButtons__buttonContainer"
            :class="{ enable: isMe('TEXT_TRANS_SCALE') }"
          >
            <div class="transUIButtons__button" @click="doScale">
              <img src="../../assets/ui/text/footer/scale.png" alt="" />
            </div>
            <div class="transUIButtons__buttonCaption">拡大・縮小</div>
          </div>
          <div
            class="transUIButtons__buttonContainer"
            :class="{ enable: isMe('TEXT_TRANS_MOVE') }"
          >
            <div class="transUIButtons__button" @click="doMove">
              <img src="../../assets/ui/text/footer/move.png" alt="" />
            </div>
            <div class="transUIButtons__buttonCaption">移動</div>
          </div>
          <div
            class="transUIButtons__buttonContainer"
            :class="{ enable: isMe('TEXT_TRANS_ROTATION') }"
          >
            <div
              class="transUIButtons__button transUIButtons__button--rot"
              @click="doRotation"
            >
              <img src="../../assets/ui/text/footer/rot.png" alt="" />
            </div>
            <div class="transUIButtons__buttonCaption">回転</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as textTypes from "../../store/modules/tool/types";
import * as StoreUtil from "../../util/StoreUtil";
import { DrawEvent } from "../../events/DrawEvent";
import * as type from "../../events/DrawEventType";
import store from "../../store";

export default {
  name: "TextEditUI",
  computed: {
    textState() {
      return this.$store.state.tool.text;
    },
    isModeTextTrans() {
      return this.textState.state == textTypes.TEXT_STATE_TRANSFORM;
    }
  },
  methods: {
    isMe(type) {
      return this.textState.transState == type;
    },
    doScale() {
      StoreUtil.textTransScale();
    },
    doMove() {
      StoreUtil.textTransMove();
    },
    doRotation() {
      StoreUtil.textTransRotation();
    },
    cancelEdit() {
      DrawEvent.emit(type.CANCEL_TEXT_EDIT);
      this.$store.dispatch(textTypes.namespace + textTypes.CANCEL_TEXT);

    },
    completeEdit() {
      DrawEvent.emit(type.COMPLETE_TEXT_EDIT);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"

.textTransformUI
    z-index: $z_header_ui
    position: absolute
    @include fit()
    pointer-events: none
    .textTransform__header
        padding: 17px 15px
        pointer-events: all
        display: flex
        justify-content: flex-end
        .buttonMini:first-child
            margin-right: 10px

    .textTransform__footer
        position: absolute
        width: 100%
        height: 50px
        bottom: 58px
        padding: 0 40px

.transUIButtons
    display: flex
    justify-content: space-between
    pointer-events: all
    max-width: 375px
    margin: auto
    overflow: hidden
    .transUIButtons__buttonContainer
        filter: brightness(0.6)
        transition: filter ease-out 0.07s
        &.enable
            filter: none
    .transUIButtons__button
      @include button
      width: 75px
      height: 75px
      radius: 75px
      background-color: #1e1e1e

      img
          transform: scale(0.5)
          display: block
      &.transUIButtons__button--rot
          img
            margin-left: -3px
    .transUIButtons__buttonCaption
        margin-top: 10px
        font-size: 13px
        text-align: center
        position: relative

</style>
